{
  "menu": {
    "description": "Guest menu",
    "items": []
  }
}
